import type { VoidFunctionComponent } from 'react';

import LabeledMultiTextInput from '../../../../generic/Forms/LabeledMultiTextInput';
import type { NoticeMatch } from '../../../../../../shared/types/routes/revisions';

import styles from '../DependencyDrawer.module.less';

type Props = {
  notice: NoticeMatch;
};

export const DependencyNotice: VoidFunctionComponent<Props> = ({ notice }) => {
  return (
    <>
      <div className={styles.noticeContents}>{notice.contents}</div>
      <LabeledMultiTextInput labelVariant="legacy" id="copyrights" values={notice.copyrights || []} label="Copyrights" isDisabled />
      <hr />
    </>
  );
};
